import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './style.css'

const rootElement = document.getElementById('root');

// Hvis der er pre-renderet indhold (f.eks. fra react-snap), skal vi bruge hydrateRoot
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <Router>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Router>
  );
} else {
  // Ellers rendere som normalt
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Router>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Router>
  );
}